var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.457 6.24112L14.5611 5.13606C14.8421 4.85452 15 4.4728 15 4.0748C15 3.67679 14.8421 3.29507 14.5611 3.01353L12.4745 0.925027C12.1888 0.652209 11.8091 0.5 11.4143 0.5C11.0194 0.5 10.6397 0.652209 10.354 0.925027L9.25 2.03009L13.457 6.24112Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 5.19737L4.20703 11.9967L5.95714 13.7485L12.75 6.94913L10.9999 5.19737Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.05893 10.261C1.03798 10.3007 1.02218 10.3429 1.01192 10.3866L0.0119143 14.8909C-0.00433246 14.9641 -0.00395877 15.04 0.0130079 15.1129C0.0299746 15.1859 0.0631011 15.2542 0.109942 15.3126C0.156783 15.3711 0.216143 15.4183 0.283641 15.4507C0.351138 15.4832 0.425049 15.5 0.49992 15.5C0.536419 15.5 0.572808 15.496 0.608421 15.488L5.10847 14.487C5.15213 14.4768 5.19431 14.461 5.23397 14.44L1.05893 10.261Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54289 2.73801L1.75 9.53735L3.50011 11.2891L10.293 4.48978L8.54289 2.73801Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.25649e981efff802ea9cfe36956df3b7.svg";
export { ForwardRef as ReactComponent };